var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", { attrs: { name: "Pending Applications" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Applications",
                    "sub-title":
                      "Manage all pending applications in GreenLists",
                    "with-footer": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c("b-pagination", {
                            staticClass: "admin-pagination mb-0",
                            attrs: {
                              "total-rows": _vm.total_in_pages,
                              "per-page": _vm.per_page,
                              align: "center",
                            },
                            on: { change: _vm.loadApplications },
                            model: {
                              value: _vm.page,
                              callback: function ($$v) {
                                _vm.page = $$v
                              },
                              expression: "page",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("admin-applications-table", {
                    attrs: { applications: _vm.applications },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }